import React from 'react'
import {UseFormMethods} from 'react-hook-form'
import {NavButtonWithSize} from 'Event/Dashboard/components/NavButton'
import BackgroundSection from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Styling/BackgroundSection'
import TypographySection from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Styling/TypographySection'
import SizeSection from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Styling/SizeSection'
import BorderSection from 'Event/Dashboard/components/NavButton/NavButtonConfig/BaseConfig/Styling/BorderSection'
import ButtonStyleClipboardActions, {
  ButtonStyleClipboard,
} from 'lib/ui/Button/ButtonStyleClipboardActions'

export default function Styling(props: {
  control: UseFormMethods['control']
  watch: UseFormMethods['watch']
  setValue: UseFormMethods['setValue']
  button: NavButtonWithSize
}) {
  const {control, button, watch, setValue} = props

  const pasteButtonStyle = (style: ButtonStyleClipboard) => {
    const set = (name: string, value: unknown) => {
      if (value === undefined) {
        return
      }

      setValue(name, value, {shouldDirty: true})
    }

    set('disableHover', style.disableHover)

    // The hover color inputs only mount on the next render when the pasted
    // disableHover reveals them, so the rest is set a tick later.
    setTimeout(() => {
      set('font', style.font)
      set('fontSize', style.fontSize)
      set('textColor', style.textColor)
      set('hoverTextColor', style.hoverTextColor)
      set('backgroundColor', style.backgroundColor)
      set('hoverBackgroundColor', style.hoverBackgroundColor)
      set('borderColor', style.borderColor)
      set('hoverBorderColor', style.hoverBorderColor)
      set('borderWidth', style.borderWidth)
      set('borderRadius', style.borderRadius)
      set('height', style.height)
      set('size', style.widthGrid)
    }, 0)
  }

  return (
    <>
      <ButtonStyleClipboardActions
        values={{
          font: watch('font', button.font),
          fontSize: watch('fontSize', button.fontSize),
          textColor: watch('textColor', button.textColor),
          hoverTextColor: watch('hoverTextColor', button.hoverTextColor),
          backgroundColor: watch('backgroundColor', button.backgroundColor),
          hoverBackgroundColor: watch(
            'hoverBackgroundColor',
            button.hoverBackgroundColor,
          ),
          disableHover: watch('disableHover', button.disableHover),
          borderColor: watch('borderColor', button.borderColor),
          hoverBorderColor: watch('hoverBorderColor', button.hoverBorderColor),
          borderWidth: watch('borderWidth', button.borderWidth),
          borderRadius: watch('borderRadius', button.borderRadius),
          height: watch('height', button.height),
          widthGrid: watch('size', button.size),
        }}
        onPaste={pasteButtonStyle}
      />
      <TypographySection
        button={button}
        control={control}
        storageKey="techcheck.customButton.config.styling.typography"
      />
      <BackgroundSection
        watch={watch}
        control={control}
        button={button}
        storageKey="techcheck.customButton.config.styling.background"
      />
      <SizeSection
        button={button}
        control={control}
        storageKey="techcheck.customButton.config.styling.size"
      />
      <BorderSection
        button={button}
        control={control}
        storageKey="techcheck.customButton.config.styling.border"
      />
    </>
  )
}
